var PriceFormatter = {

    format: function(price){
        if(!price){
            return '';
        }

        price = String(price);
        
        var amount = price.substr(0, price.length - 2); 
        var decimals = price.substr(price.length - 2)

        // Build price.
        var value = '';
        if(PriceFormatter.currencySignAtStart){
            value = PriceFormatter.currencySign;
        }

        if(amount.length > 3){
            amount = PriceFormatter.stringReverse(amount);
            amount = amount.replace(/(.{3})/g, "$1" + PriceFormatter.thousandsSeparator);
            amount = PriceFormatter.stringReverse(amount);
        }

        value += amount;

        if(PriceFormatter.showDecimals){
            value += PriceFormatter.decimalSeparator + decimals;
        }

        if(PriceFormatter.currencySignAtEnd){
            value += PriceFormatter.currencySign;
        }

        return value;
    },

    stringReverse: function(s) {
        var o = '';
        for (var i = s.length - 1; i >= 0; i--)
          o += s[i];
        return o;
    },

    showPrice: function(parentQuery, price, comparePrice){
        PriceFormatter.showPriceByElement($(parentQuery), price, comparePrice);
    },

    showPriceByElement: function(element, price, comparePrice){
        if(price == comparePrice || PriceFormatter.showComparePrice == 'no'){
            comparePrice = '';
        }

        element.find('span.price s').html(PriceFormatter.format(comparePrice));
        element.find('span.price span').html(PriceFormatter.format(price));
    }

};

$(document).ready(function(){
    // Price pattern
    PriceFormatter.showComparePrice = $.trim($('body').attr('data-show-compare-price'));
    
    var pp = $.trim($('body').attr('data-price-pattern'));
    PriceFormatter.pricePattern = pp;
    PriceFormatter.currencySignAtStart = pp.indexOf('1') != 0;
    PriceFormatter.currencySignAtEnd = pp.indexOf(6) != pp.length - 1;
    
    if(PriceFormatter.currencySignAtStart){
        PriceFormatter.currencySign = pp.substr(0,pp.indexOf(1));
    }
    else if(PriceFormatter.currencySignAtEnd){
        PriceFormatter.currencySign = pp.substr(pp.indexOf(6) + 1);
    }

    PriceFormatter.thousandsSeparator = pp.substring(pp.indexOf(1) + 1, pp.indexOf(2));
    PriceFormatter.showDecimals = pp.indexOf(5) !== -1;
    if(PriceFormatter.showDecimals){
        PriceFormatter.decimalSeparator = pp.substring(pp.indexOf(4) + 1, pp.indexOf(5));
    }
    else{
        PriceFormatter.decimalSeparator = '';
    }

    // Announcement bar.
    if($('.header-announcement-bar').attr('data-use-slideshow') == 'true'){
        new Swiper(".header-announcement-bar", {
            slidesPerView: 1,
            centeredSlides: true,
            autoplay:{
                delay: parseInt($('.header-announcement-bar').attr('data-slideshow-speed')) * 1000,
                disableOnInteraction: false
            }
        });
    }
    
    // Header handling.
    $('main').css('padding-top', $('#header').outerHeight());

    // Mobile menu
    $('.header-menu-mobile-menu').click(openMobileMenu);
    $('.mobile-menu-header-close-icon').click(closeMobileMenu);
    $('#mobile-menu-overlay').click(closeMobileMenu);

    $('.header-menu-logo img').clone().prependTo('.mobile-menu-header');
    $('.mobile-menu-header img').css('height', 'auto');

    // Cart drawer.
    $('.header-menu-cart-drawer').click(openCartDrawer);
    $('.cart-drawer-header-close-icon').click(closeCartDrawer);
    $('#cart-drawer-overlay').click(closeCartDrawer);

    initCart();

    // Footer
    $('.footer-column-menu h2').click(toggleFooterLinkList);

    // Product page
    if($('.template-product').length > 0 && $('.product-media-main').length > 0){ // Redesign v2: nur alte Produktsektion
        handleProductPage();
    }

    // Collection page
    if($('.template-collection').length > 0){
        handleCollectionPage();
    }

    // Section handling. Sections can be placed everywhere.
    // Therefore, we do not only handle them on one specific page.
    handleSections();
});

function openMobileMenu(){
    $('#mobile-menu').css('visibility', 'visible');

    $('#mobile-menu-overlay').css('opacity', '0.5');
    $('#mobile-menu-content').css('transform', 'translateX(0%)');
}

function closeMobileMenu(){
    setTimeout(function(){
        $('#mobile-menu').css('visibility', 'hidden');
    }, 200);

    $('#mobile-menu-overlay').css('opacity', '0');
    $('#mobile-menu-content').css('transform', 'translateX(-100%)');
}

function openCartDrawer(){
    if($(document).width() < 768){
        $('#cart-drawer .cart-drawer-content').css('width', '100%');
    }
    else{
        $('#cart-drawer .cart-drawer-content').css('width', '35%');
    }

    $('#cart-drawer').css('visibility', 'visible');

    $('#cart-drawer-overlay').css('opacity', '0.5');
    $('#cart-drawer .cart-drawer-content').css('transform', 'translateX(0%)');
}

function closeCartDrawer(){
    setTimeout(function(){
        $('#cart-drawer').css('visibility', 'hidden');
    }, 200);

    $('#cart-drawer-overlay').css('opacity', '0');
    $('#cart-drawer .cart-drawer-content').css('transform', 'translateX(100%)');
}

function toggleFooterLinkList(){
    if($(document).width() >= 768){
        return;
    }

    var ul = $(this).next();

    if(ul.css('display') == 'none'){
        $(this).find('span:last-child').text('-');
        ul.show();
    }
    else{
        $(this).find('span:last-child').text('+');
        ul.hide();
    }
}

function showLoadingIndicator(){
    $('#loading-indicator').css('display', 'flex');
}

function hideLoadingIndicator(){
    $('#loading-indicator').css('display', 'none');
}

/* ======================================= */
/* =============== PRODUCT =============== */
/* ======================================= */

function handleProductPage(){
    // Swiper.
    var showThumbnails = $('.product-media-main').attr('data-thumbnails');
    var mobileVertical = $('.product-media-main').attr('data-mobile-vertical');
    var mobileFullWidth = $('.product-media-main').attr('data-mobile-full-width');
    var spaceBetweenThumbnails = parseInt($('.product-media-main').attr('data-space-between-thumbnails'));
    var mainSwiperSpaceBetween = 10;

    if(spaceBetweenThumbnails > 0){
        mainSwiperSpaceBetween = spaceBetweenThumbnails;
    }

    var mainSwiperOptions = {
        pagination: {
            el: '.product-media-main .swiper-pagination'
        },
        slidesPerView: 1,
        spaceBetween: 0
    };

    if(mobileFullWidth != 'true'){
        mainSwiperOptions.spaceBetween = mainSwiperSpaceBetween;
    }
    if(showThumbnails == 'true'){
        mainSwiperOptions.thumbs = {
            swiper: new Swiper('.product-media-thumbnail', {
                slidesPerView: 5,
                spaceBetween: spaceBetweenThumbnails,
                slideToClickedSlide: true
            })        
        };
    }
    if(mobileVertical == 'true'){
        mainSwiperOptions.direction = 'vertical';
        mainSwiperOptions.touchReleaseOnEdges = true;
        mainSwiperOptions.resistanceRatio = 0;
        mainSwiperOptions.mousewheel = {
            releaseOnEdges: true
        };
        mainSwiperOptions.breakpoints = {
            768:{
                direction: 'horizontal',
                spaceBetween: mainSwiperSpaceBetween
            }
        };

        $('.product-media-main').height($('.product-media-main').width());
    }
    else{
        mainSwiperOptions.breakpoints = {
            768:{
                spaceBetween: mainSwiperSpaceBetween
            }
        };
    }

    var mainSwiper = new Swiper('.product-media-main', mainSwiperOptions);

    $('.product-media-main img').click(function(){
        mainSwiper.slideNext();
    });

    // Quantity.
    $('.product-information-quantity button[name="minus"]').click(function(){
        if($('#product-information-cart-button').attr('disabled')){
            return;
        }

        var input = $('.product-information-quantity-field');
        var span = $('.product-information-quantity-input');
        var value = Math.max(1, parseInt(input.val()) - 1);
        span.text(value);
        input.val(value);

        if(value == 1){
            $('.product-information-quantity button[name="minus"] svg path').css('stroke', 'var(--color-border)');
        }
    });
    $('.product-information-quantity button[name="plus"]').click(function(){
        if($('#product-information-cart-button').attr('disabled')){
            return;
        }

        var input = $('.product-information-quantity-field');
        var span = $('.product-information-quantity-input');
        var value = parseInt(input.val()) + 1;

        if($(this)[0].hasAttribute('data-stock')){
            value = Math.min(value, $(this).attr('data-stock'));
        }

        span.text(value);
        input.val(value);

        $('.product-information-quantity button[name="minus"] svg path').css('stroke', 'var(--color-text)');
    });

    // Variant.
    $('.product-variant-select').change(setupSelectedVariant);
    $('.product-variant-radio').change(setupSelectedVariant);

    $('.product-information-variant-picker-button-variant-option').click(function(){
        var radio = $(this).find('.product-variant-radio');
        $('.product-variant-radio[name="' + radio.attr('name') + '"]').removeAttr('checked');
        radio.attr('checked', true);
        
        setupSelectedVariant();
    });

    $('.product-information-variant-picker-button-box').click(function(e){
        var variants = $(this).find('.product-information-variant-picker-button-variants');
        if(variants.css('display') == 'none'){
            variants.css('display', 'flex');
            $(this).find('svg').css('rotate', '90deg');
            return;
        }

        if(
            $(e.target).is('.product-information-variant-picker-button-variant label') || 
            $(e.target).is('.product-information-variant-picker-button-variant label *')
        ){
            variants.css('display', 'none');
            $(this).find('svg').css('rotate', '0deg');
        }
    });

    setupSelectedVariant();

    // Form.
    $('form').submit(function(event){
        event.preventDefault();

        if($('#product-information-cart-button').attr('disabled')){
            return;
        }

        showLoadingIndicator();

        $.ajax({
            type: 'POST', 
            url: '/cart/add.js',
            dataType: 'json', 
            data: $(this).serialize(),
            success: function(data){
                loadCartData(function(data){
                    openCartDrawer();
                    createCartItems(data);

                    hideLoadingIndicator();
                });
            },
            error:function(response){
                hideLoadingIndicator();

                if(response && response.responseJSON && response.responseJSON.description){
                    alert(response.responseJSON.message + "\n\n" + response.responseJSON.description);
                }
                else{
                    alert('Es ist ein Fehler aufgetreten. Bitte versuches es noch einmal.');
                }
            }
        });
    });

    // Scroll to form button.
    $('.product-information-scroll-to-form').click(function(){
        var scrollTop = 0;

        if($('#product-information-cart-button').length > 0){
            scrollTop = $('#product-information-cart-button').offset().top - (window.screen.height / 2);
        }

        $('html, body').animate({
            scrollTop: scrollTop
        }, 500);
    });
}

function setupSelectedVariant(){
    var options = [];
    $('.product-variant-select').each(function(){
        options.push({
            key: 'option' + (product.options.indexOf($(this).attr('name')) + 1),
            value: $(this).val()
        });
    });

    $('.product-information-variant-picker-button-variant-option').removeClass('product-information-variant-picker-button-variant-option-checked');
    $('.product-variant-radio:checked').each(function(){
        $(this).parent().addClass('product-information-variant-picker-button-variant-option-checked');

        var span = $(this).parents('.product-information-variant-picker-button-variant').find('label span:eq(1)');
        if(span.attr('data-color-swatch') == "true"){
            span.html($(this).val() + '<span class="color-swatch" style="background-color: ' + $(this).next().css('background-color') + ';"></span>');

            $(this).parents('.product-information-variant-picker-button-variant').find('label span:eq(0) div').html(': ' + $(this).val());
        }
        else{
            span.html($(this).val());
        }

        options.push({
            key: 'option' + (product.options.indexOf($(this).attr('name')) + 1),
            value: $(this).val()
        });
    });

    var selectedVariant = product.variants.find(function(variant) {
        return options.every(function(values) {
            return variant[values.key] === values.value;
        });
    });

    $('input[name="id"]').val(selectedVariant.id);

    // Handle inventory.
    $('#product-information-cart-button').removeAttr('disabled');
    $('.product-information-quantity').css('opacity', '1');
    $('#product-information-cart-button span').text($('#product-information-cart-button').attr('data-text-normal'));

    if(variantStock.hasOwnProperty(selectedVariant.id)){
        $('.product-information-quantity button[name="plus"]').attr('data-stock', variantStock[selectedVariant.id]);

        $('.product-information-quantity').each(function(){
            var input = $('.product-information-quantity-field');
            var value = parseInt(input.val());
            if(value > variantStock[selectedVariant.id]){
                value = variantStock[selectedVariant.id];
            }
            else if(value == 0 && variantStock[selectedVariant.id] > 0){
                value = 1;
            }
    
            $(this).find('.product-information-quantity-input').text(value);
            input.val(value);
    
            if(value < 2){
                $(this).find('button[name="minus"] svg path').css('stroke', 'var(--color-border)');
            }
            else{
                $(this).find('button[name="minus"] svg path').css('stroke', 'var(--color-text)');
            }

            // Disable button.
            if(value == 0){
                $('#product-information-cart-button').attr('disabled', true);
                $('.product-information-quantity').css('opacity', '0.4');
                $('#product-information-cart-button span').text($('#product-information-cart-button').attr('data-text-disabled'));
            }
        });
    }
    else{
        $('.product-information-quantity button[name="plus"]').removeAttr('data-stock');

        $('.product-information-quantity').each(function(){
            var input = $('.product-information-quantity-field');
            var value = parseInt(input.val());
            if(value != 0){
                return;
            }

            value = 1;
    
            $('.product-information-quantity-input').text(value);
            input.val(value);
    
            $('button[name="minus"] svg path').css('stroke', 'var(--color-border)');
        });
    }

    // Show price.
    PriceFormatter.showPrice('.product-information-price', selectedVariant.price, selectedVariant.compare_at_price);

    // Handle price discount badge.
    if($('.product-information-price-saved').length == 0){
        return;
    }

    if(selectedVariant.compare_at_price > selectedVariant.price){
        $('.product-information-price-saved').show();
    }
    else{
        $('.product-information-price-saved').hide();
    }

    if($('.product-information-price-saved').attr('data-type') == 'percentage'){
        var value = (selectedVariant.compare_at_price - selectedVariant.price) * 100 / selectedVariant.compare_at_price;
        $('.product-information-price-saved span').html(Math.ceil(value) + '%');
    }
    else{
        PriceFormatter.showPrice('.product-information-price-saved span', selectedVariant.compare_at_price - selectedVariant.price);
    }
}

/* ==================================== */
/* =============== CART =============== */
/* ==================================== */

function initCart(){
    $('.cart-drawer-content').on('click', '.cart-drawer-item-quantity-minus', function(){
        var lineIndex = $(this).attr('data-line-index');
        var input = $('#cart-drawer-item-quantity-input-' + lineIndex);
        input.val(parseInt(input.val()) - 1);

        updateCartItemQuantity(lineIndex, input.val());
    });
    $('.cart-drawer-content').on('click', '.cart-drawer-item-quantity-plus', function(){
        var lineIndex = $(this).attr('data-line-index');
        var input = $('#cart-drawer-item-quantity-input-' + lineIndex);
        var value = parseInt(input.val()) + 1;

        if($(this)[0].hasAttribute('data-stock') && value > parseInt($(this).attr('data-stock'))){
            return;
        }

        input.val(value);

        updateCartItemQuantity(lineIndex, input.val());
    });
    $('.cart-drawer-content').on('click', '.cart-drawer-item-remove', function(){
        updateCartItemQuantity($(this).attr('data-line-index'), 0);
    });
}

function updateCartItemQuantity(line, quantity){
    showLoadingIndicator();

    $.ajax({
        type: 'POST', 
        url: '/cart/change',
        dataType: 'json', 
        data: {
            line: line,
            quantity: quantity
        },
        success: function(){
            loadCartData(function(data){
                createCartItems(data);

                hideLoadingIndicator();
            });
        },
        error:function(){
            alert('Es ist ein Fehler aufgetreten. Bitte versuches es noch einmal.');
        }
    });
}

function loadCartData(callback){
    $.ajax({
        type: 'GET', 
        url: '/cart.js',
        dataType: 'json', 
        success: function(data){
            if(callback){
                callback(data);
            }
        },
        error:function(){
            alert('Es ist ein Fehler aufgetreten. Bitte versuches es noch einmal.');
        }
    });
}

function createCartItems(cartData){
    var totalQuantity = 0;

    if(!cartData || !cartData.items || cartData.items.length == 0){
        $('.cart-drawer-empty').show();
        $('.cart-drawer-contents').hide();
        $('.cart-drawer-footer').hide();

        $('#header-cart-drawer-item-count').text(totalQuantity);
        $('#header-cart-drawer-item-count').hide();
        return;
    }

    $('.cart-drawer-empty').hide();
    $('.cart-drawer-contents').show();
    $('.cart-drawer-footer').show();

    $('.cart-drawer-item').not('.cart-drawer-item-temp').remove();

    $('.cart-drawer-items').each(function(parentIndex, parent){
        cartData.items.forEach(function(item, index){
            var element = $(parent).find('.cart-drawer-item-temp').clone();
            element.appendTo($(parent));
            element.removeClass('cart-drawer-item-temp');
            element.show();

            element.find('.cart-drawer-item-image').attr('src', item.image);
            
            var data = element.find('.cart-drawer-item-data');
            data.find('h3').text(item.product_title);

            // Options
            if(item.options_with_values && item.options_with_values.length > 0){
                var options = data.find('.cart-drawer-item-options');

                item.options_with_values.forEach(function(option){
                    options.append(
                        '<div class="cart-drawer-item-option"><span>' + option.name + ':</span> ' + option.value + '</div>'
                    );
                });
            }

            // Properties
            if(item.properties && Object.keys(item.properties).length > 0){
                var properties = data.find('.cart-drawer-item-properties');

                for(var key in item.properties){
                    if(item.properties.hasOwnProperty(key)){
                        var value = item.properties[key];

                        if(value.indexOf('/uploads/') !== -1){
                            var brackets = value.split('/');
                            value = '<a href="' + value + '" target="_blank">' + brackets[brackets.length - 1] + '</a>';
                        }

                        properties.append(
                            '<div class="cart-drawer-item-option"><span>' + key + ':</span> ' + value + '</div>'
                        );
                    }
                }
            }

            // Price
            var variant = product.variants.find(v => v.id == item.variant_id);

            if(variant && variant.compare_at_price != item.final_line_price){
                PriceFormatter.showPriceByElement(data.find('.cart-drawer-item-price'), item.final_line_price, variant.compare_at_price);
            }
            else{
                PriceFormatter.showPriceByElement(data.find('.cart-drawer-item-price'), item.original_line_price);
            }

            // Quantity + Remove
            data.find('.cart-drawer-item-quantity-minus').attr('data-line-index', index + 1);
            data.find('.cart-drawer-item-quantity-plus').attr('data-line-index', index + 1);
            data.find('.cart-drawer-item-remove').attr('data-line-index', index + 1);

            data.find('.cart-drawer-item-quantity input').attr('id', 'cart-drawer-item-quantity-input-' + String(index + 1));
            data.find('.cart-drawer-item-quantity input').val(item.quantity);

            totalQuantity += item.quantity;
        });
    });

    // Cart drawer footer.
    PriceFormatter.showPrice('.cart-drawer-footer-subtotal', cartData.items_subtotal_price);
    PriceFormatter.showPrice('.cart-drawer-footer-total', cartData.total_price);

    // Header.
    $('#header-cart-drawer-item-count').text(totalQuantity);
    
    if(parseInt(totalQuantity) > 0){
        $('#header-cart-drawer-item-count').show();
        $('#header-cart-drawer-item-count').removeClass('hide');
    }
    else{
        $('#header-cart-drawer-item-count').hide();
    }
}

/* ========================================== */
/* =============== COLLECTION =============== */
/* ========================================== */

function handleCollectionPage(){
    var currentPage = 1;
    var allowFetchPages = true;
    var isLoading = false;

    $(window).scroll(function(){
        if(!allowFetchPages || isLoading){
            return;
        }

        var scrollPosition = $(window).scrollTop() + window.screen.height * 1.3;
        var gridBottom = $('.collection-product-grid').offset().top + $('.collection-product-grid').height();

        if(scrollPosition < gridBottom){
            return;
        }

        currentPage++;
        isLoading = true;

        $('.collection-product-grid-loading').show();

        $.ajax({ 
            url: '?page=' + currentPage,
            success: function(data){
                $('.collection-product-grid-loading').hide();
                isLoading = false;

                if(!data){
                    return;
                }

                var html = $(data);
                if(html.find('.card-product').length > 0){
                    $('.collection-product-grid-cards').append(html.find('.collection-product-grid-cards').html());
                    return;
                }

                allowFetchPages = false;
            },
            error:function(){
                $('.collection-product-grid-loading').hide();
                isLoading = false;
            }
        });
    });
}

/* ======================================== */
/* =============== SECTIONS =============== */
/* ======================================== */

function handleSections(){
    // Collapsible Content.
    $('.collapsible-content-row-header').click(function(){
        $(this).find('svg').css('rotate', '90deg');
        $(this).find('h3 span:last-child').text('-');
        $(this).next().toggle();

        if($(this).next().css('display') == 'none'){
            $(this).find('svg').css('rotate', '0deg');
            $(this).find('h3 span:last-child').text('+');
        }
    });

    // Collection
    new Swiper(".section-collection-cards",{
        slidesPerView: 2.5,
        spaceBetween: 20,
        grabCursor: true,
        breakpoints: {
            768: {
                slidesPerView: 3.5
            }
        }
    });

    // Custom reviews
    new Swiper(".custom-reviews-cards",{
        loop: true,
        navigation: {
            nextEl: '.custom-reviews-cards .swiper-button-next',
            prevEl: '.custom-reviews-cards .swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 20
            }
        }
    });

    // Video Banner
    $('.video-banner').each(function(){
        if($(this).find('video').length == 0){
            return;
        }

        videoBannerVideoLoaded($(this), $(this).find('video'));
    });

    // Selling point slider
    $('.selling-point-slider').each(function(){
        new Swiper($(this)[0], {
            slidesPerView: 1,
            centeredSlides: true,
            loop: true,
            autoplay:{
                delay: parseInt($(this).attr('data-slideshow-speed')) * 1000,
                disableOnInteraction: false
            },
            breakpoints: {
                768: {
                    centeredSlides: false,
                    slidesPerView: parseInt($(this).attr('data-desktop-slides-per-view'))
                }
            }
        });
    });    
}

function videoBannerVideoLoaded(videoBanner, video){
    if(video[0].readyState != 4){
        setTimeout(function(){
            videoBannerVideoLoaded(videoBanner, video);
        }, 50);
        return;
    }

    videoBanner.css('padding-bottom', (video.height() / video.width() * 100) + '%');
}